import _request from '@/utils/request.js'

var _service = {
    // 是否标准		
    getIsStandardList (resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/stored/order/getIsStandardList"),
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 获取福利兑换活动
    getIdTitleAllWelfare (resolve, reject) {
        _request.api({
            url     : _request.getCrmUrl("/api/activity/getIdTitleAllWelfare"),
            method  : 'get',
            success : resolve,
            error   : reject
          })
    },
    // 封装活动信息列表接口		
    getIdTitleByOwnerIdWelfare (isOwner, resolve, reject) {
        _request.api({
            url     : _request.getCardsUrl("/api/activity/getIdTitleByOwnerIdWelfare"),
            params  : {
                isOwner: isOwner ? 1 : 2,
                inProgress: 1
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
}

export default _service